import AILoadingSpinner from "@/components/AIComponents/AILoadingSpinner";
import {
  bodyStyles,
  loadingLabelStyles,
  loadingSpinnerStyles,
} from "./TranslateDrawer.style";

const TranslateDrawerLoading = () => {
  return (
    <div css={bodyStyles}>
      <AILoadingSpinner __cssFor={{ root: loadingSpinnerStyles }} />
      <p css={loadingLabelStyles}>Translating...</p>
    </div>
  );
};

export default TranslateDrawerLoading;
